import { Typography } from "@material-ui/core"

const Commercial = (props) => {

  return ( <>
    <Typography>
      Not by default, but we’re open to discussing it! While we retain the rights to all songs we create, if you’re interested in using yours for commercial purposes—like selling it, using it in a business, or monetizing it through streaming—reach out to us, and we can work out a licensing agreement.
    </Typography>
  </> )
}

export default Commercial
